export enum Status {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
}
